import getExtensionFromFileName from './getExtensionFromFileName';
import tryGetExtensionFromFileType from './tryGetExtensionFromFileType';

const imageFileExtensions: string[] = [
    '.bmp',
    '.gif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.jfif',
    '.dib',
    '.png',
    '.psd',
];

export default function isImageFile(fileName: string, fileType?: string): boolean {
    // Sometimes, exchange server returns us the name like ATT00001, so it is necessary to check
    // for fileType as well if fileName does not contain the extension.
    // https://o365exchange.visualstudio.com/O365%20Core/_git/Substrate?version=GBmaster&path=/sources/dev/EdgeExtensibility/src/Core/EmailMessage/Attachment.cs
    const extension: string =
        getExtensionFromFileName(fileName) || tryGetExtensionFromFileType(fileType);
    if (extension) {
        return imageFileExtensions.indexOf(extension.toLowerCase()) >= 0;
    }

    return false;
}
